export default [
  {
    path: '/operationDetail',
    name: 'operationDetail',
    meta: {
      title: '手术详情'
    },
    component: () => import('@/views/operationDetail')
  }
]
